import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "construction-worker-create" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bedrijf (contractpartij) / Company (contracting party) "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Medewerker is ingehuurd door een contractpartij "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bedrijfsnaam medewerker (niet de naam van de contractpartij) "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Document type "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Nationaliteit / Nationality "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Land van uitgifte / Country of issue "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - BSN / Personal identification number "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_9 = {
  key: 0,
  style: {"display":"block","color":"#ff8200","margin-bottom":"8px"}
}
const _hoisted_10 = {
  key: 1,
  style: {"display":"block","color":"#ff8200","margin-bottom":"8px"}
}
const _hoisted_11 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Voornaam / Firstname "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Achternaam / Lastname "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Geboortedatum / Date of birth "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Documentnummer / Document number "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_16 = {
  key: 0,
  style: {"display":"block","color":"#ff8200","margin-bottom":"8px"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Geldig tot / Date of expiry "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Kopie voorkant / Copy front "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID - Kopie achterkant / Copy back "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Portretfoto / Photo", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Postcode / Zipcode "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Huisnummer / Housenumber "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Straat / Street "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Plaats / City "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Verblijfsvergunning / Residence permit "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Nederlandse werkvergunning / Dutch work permit "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"block","margin-bottom":"4px"} }, "Let op! Dit dient een Nederlandse werkvergunning te zijn. Buitenlandse vergunningen en aanvraagformulieren zijn NIET geldig!", -1)
const _hoisted_29 = {
  key: 0,
  class: "error"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Werkvergunningsnummer / Work permit number "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Werkvergunning geldig tot / Work permit date of expiry "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Werkvergunning voorkant / Work permit front "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Werkvergunning achterkant / Work permit back "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("VCA gecertificeerd / Certified "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("VCA - Geldig tot / Date of expiry "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("In bezit van GPI / In possession of GPI "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("GPI - Geldig tot / Date of expiry "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("In bezit van PU certificaat / In possession of PU certificate "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("PU - Geldig tot / Date of expiry "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Handtekening / Signature "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import dayjs, { Dayjs } from 'dayjs'
import { validatePIN } from '@/bsnvalidator'
import { ConstructionWorker } from '@/types/constructionWorker'
import Uploader from '@/components/Uploader.vue'
import UploadQueue from '@/components/UploadQueue.vue'
import SignatureField from '@/components/SignatureField.vue'
import { notification } from 'ant-design-vue'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import { authStore } from '@/stores/auth'
import PageTitleBar from '@/components/PageTitleBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConstructionWorkerCreate',
  setup(__props) {

const companies = ref([])
const countries = ref([])
const validBSN = ref(true)
let companyTimer = 0
let addressTimer = 0
const disabledDatesOfBirth = (current: Dayjs) => current > dayjs().subtract(16, 'year')
const disabledDatesInPast = (current: Dayjs) => current < dayjs().startOf('day')
const router = useRouter()

const EERMember = computed(() => {
  let EERMember = 1
  countries.value.forEach((n:{ id:number, name:string, nationality:string, EER_member:number }) => {
    if (n.id === constructionWorker.value.document_country_id) {
      EERMember = n.EER_member
    }
  })
  return EERMember
})

const signatureName = computed(() => {
  if (constructionWorker.value.firstname && constructionWorker.value.lastname) {
    return 'Handtekening ' + constructionWorker.value.firstname + ' ' + constructionWorker.value.lastname
  }

  return 'Handtekening bouwplaatsmedewerker'
})

const requiredFieldsCompleted = computed(() => {
  let rfc = false
  const minRequired = !!(
    constructionWorker.value.company_id &&
    (constructionWorker.value.is_subcontractor ? !!constructionWorker.value.subcontractor_company_name : true) &&
    constructionWorker.value.firstname &&
    constructionWorker.value.lastname &&
    constructionWorker.value.street &&
    constructionWorker.value.housenumber &&
    constructionWorker.value.zipcode &&
    constructionWorker.value.city &&
    constructionWorker.value.date_of_birth &&
    constructionWorker.value.nationality_id &&
    constructionWorker.value.document_type &&
    constructionWorker.value.document_country_id &&
    constructionWorker.value.personal_identification_number &&
    validBSN &&
    constructionWorker.value.document_number &&
    constructionWorker.value.document_expiry_date &&
    (constructionWorker.value.vca_certified === 0 ? true : (!!(constructionWorker.value.vca_expiry_date))) &&
    (constructionWorker.value.gpi_certified === 0 ? true : (!!(constructionWorker.value.gpi_expiry_date))) &&
    (constructionWorker.value.pu_certified === 0 ? true : (!!(constructionWorker.value.pu_expiry_date))) &&
    constructionWorker.value.signature.length
  )

  if (EERMember.value) {
    rfc = minRequired
  } else {
    rfc = !!(
      minRequired &&
      constructionWorker.value.idFront.length &&
      constructionWorker.value.idBack.length &&
      constructionWorker.value.residence_permit &&
      constructionWorker.value.work_permit &&
      constructionWorker.value.work_permit_number &&
      constructionWorker.value.work_permit_expiry_date &&
      constructionWorker.value.permitFront.length &&
      constructionWorker.value.permitBack.length
    )
  }

  return rfc
})

const constructionWorker = ref<ConstructionWorker>({
  company_id: !authStore().isInternal ? authStore().user.company_id : null,
  company: null,
  is_subcontractor: false,
  subcontractor_company_name: null,
  firstname: null,
  lastname: null,
  street: null,
  housenumber: null,
  address: null,
  zipcode: null,
  city: null,
  date_of_birth: dayjs().subtract(16, 'year'),
  nationality_id: 92,
  nationality: null,
  document_type: 1,
  document_country_id: 92,
  country: null,
  EERMember: null,
  personal_identification_number: null,
  document_number: null,
  document_expiry_date: null,
  residence_permit: null,
  work_permit: null,
  work_permit_number: null,
  work_permit_expiry_date: null,
  vca_certified: 0,
  vca_expiry_date: null,
  gpi_certified: 0,
  gpi_expiry_date: null,
  pu_certified: 0,
  pu_expiry_date: null,
  portraitPhoto: [],
  idFront: [],
  idBack: [],
  permitFront: [],
  permitBack: [],
  signature: [],
  denied: {
    is_denied: false,
    denied_by_user: null,
    denied_at: null,
    reason: null
  }
})

onMounted(() => {
  getCountries()
})

function storeConstructionWorker () : void {
  const data = {
    ...constructionWorker.value,
    date_of_birth: constructionWorker.value.date_of_birth ? dayjs(constructionWorker.value.date_of_birth).format('YYYY-MM-DD HH:mm:ss') : null,
    document_expiry_date: constructionWorker.value.document_expiry_date ? dayjs(constructionWorker.value.document_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    work_permit_expiry_date: constructionWorker.value.work_permit_expiry_date ? dayjs(constructionWorker.value.work_permit_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    vca_expiry_date: constructionWorker.value.vca_expiry_date ? dayjs(constructionWorker.value.vca_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    gpi_expiry_date: constructionWorker.value.gpi_expiry_date ? dayjs(constructionWorker.value.gpi_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null,
    pu_expiry_date: constructionWorker.value.pu_expiry_date ? dayjs(constructionWorker.value.pu_expiry_date).format('YYYY-MM-DD HH:mm:ss') : null
  }

  axios.post(process.env.VUE_APP_API_URL + '/constructionWorkers', data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
    notification.success({
      message: 'Medewerker succesvol toegevoegd.',
      description: 'De medewerker is succesvol toegevoegd. Je kunt hem nu op een project registreren.',
      duration: 5
    })
    router.push({ name: 'ConstructionWorkers' })
    constructionWorker.value = {
      company_id: null,
      company: null,
      is_subcontractor: false,
      subcontractor_company_name: null,
      firstname: null,
      lastname: null,
      street: null,
      housenumber: null,
      address: null,
      zipcode: null,
      city: null,
      date_of_birth: null,
      nationality_id: 92,
      nationality: null,
      document_type: 1,
      document_country_id: 92,
      country: null,
      EERMember: null,
      personal_identification_number: null,
      document_number: null,
      document_expiry_date: null,
      residence_permit: null,
      work_permit: null,
      work_permit_number: null,
      work_permit_expiry_date: null,
      vca_certified: 0,
      vca_expiry_date: null,
      gpi_certified: 0,
      gpi_expiry_date: null,
      pu_certified: 0,
      pu_expiry_date: null,
      portraitPhoto: [],
      idFront: [],
      idBack: [],
      permitFront: [],
      permitBack: [],
      signature: [],
      denied: {
        is_denied: false,
        denied_by_user: null,
        denied_at: null,
        reason: null
      }
    }
  }).catch((e) => {
    if (e.response.status === 406) {
      notification.error({ message: 'De persoon met dit BSN-nummer is al geregistreerd!', description: 'Je kunt iemand maar één keer toevoegen. Zoek deze persoon op in de lijst.', duration: 0 })
    } else {
      notification.error({ message: 'Fout tijdens opslaan van bouwplaatsmedewerker!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.', duration: 0 })
    }
  })
}

function searchCompanies (val:string) : void {
  if (val.length >= 3) {
    clearTimeout(companyTimer)
    constructionWorker.value.company_id = null

    companyTimer = setTimeout(() => {
      axios.get(process.env.VUE_APP_API_URL + '/companies?filter[search]=' + val).then((res) => {
        companies.value = res.data.data
      })
    }, 500)
  } else {
    companies.value = []
  }
}

function getAddressByZipcode () {
  constructionWorker.value.zipcode = constructionWorker.value.zipcode ? constructionWorker.value.zipcode.replace(' ', '').toUpperCase() : null
  if (constructionWorker.value.zipcode && constructionWorker.value.housenumber && constructionWorker.value.zipcode.length === 6) {
    clearTimeout(addressTimer)
    constructionWorker.value.street = null
    constructionWorker.value.city = null

    addressTimer = setTimeout(() => {
      const axiosWithoutHeaders = axios.create()
      delete axiosWithoutHeaders.defaults.headers.common.Authorization

      axiosWithoutHeaders.get('https://api.pdok.nl/bzk/locatieserver/search/v3_1/suggest?q=' + constructionWorker.value.zipcode + '-' + constructionWorker.value.housenumber + '&fl=straatnaam,woonplaatsnaam').then((r) => {
        if (r.data.response.numFound > 0) {
          constructionWorker.value.street = r.data.response.docs[0].straatnaam
          constructionWorker.value.city = r.data.response.docs[0].woonplaatsnaam
        } else {
          constructionWorker.value.street = null
          constructionWorker.value.city = null
        }
      })
    }, 500)
  } else {
    constructionWorker.value.street = null
    constructionWorker.value.city = null
  }
}

function getCountries () : void {
  axios.get(process.env.VUE_APP_API_URL + '/countries?limit=250&sort=name').then((r) => {
    countries.value = r.data.data
  })
}

function countryOfIssueChanged (val:number) : void {
  constructionWorker.value.document_country_id = val
  constructionWorker.value.residence_permit = null
  constructionWorker.value.work_permit = null
  constructionWorker.value.work_permit_number = null
  constructionWorker.value.work_permit_expiry_date = null
}

function saveSignature (file:File) : void {
  constructionWorker.value.signature = [file]
}

function filterItems (inputValue:string, option:{ id:string, name:string }) {
  return option.name.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
}

function filterNationalities (inputValue:string, option:{ id:string, nationality:string }) {
  return option.nationality.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
}

function validateBSN () {
  if (constructionWorker.value.document_country_id && constructionWorker.value.personal_identification_number) {
    validBSN.value = validatePIN(constructionWorker.value.document_country_id, constructionWorker.value.personal_identification_number)
    axios.post(process.env.VUE_APP_API_URL + '/constructionWorkers/check', {
      personal_identification_number: constructionWorker.value.personal_identification_number
    }).catch((e) => {
      if (e.response.status === 406) {
        notification.error({
          message: 'De persoon met dit BSN-nummer is al geregistreerd!',
          description: 'Je kunt iemand maar één keer toevoegen. Zoek deze persoon op in de lijst.',
          duration: 0
        })
      }
    })
  } else {
    validBSN.value = true
  }
}

function vcaChanged () : void {
  if (constructionWorker.value.vca_certified === 0) {
    constructionWorker.value.vca_expiry_date = null
  }
}

function gpiChanged () : void {
  if (constructionWorker.value.gpi_certified === 0) {
    constructionWorker.value.gpi_expiry_date = null
  }
}

function puChanged () : void {
  if (constructionWorker.value.pu_certified === 0) {
    constructionWorker.value.pu_expiry_date = null
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Medewerker toevoegen.")
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'ConstructionWorkers' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { title: "Gegevens medewerker" }, {
              default: _withCtx(() => [
                (_unref(authStore)().isInternal)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createVNode(_component_a_select, {
                              placeholder: "Begin met typen om te zoeken..",
                              "default-active-first-option": false,
                              "filter-option": false,
                              fieldNames: { label: 'name', value: 'id' },
                              options: companies.value,
                              value: constructionWorker.value.company_id,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((constructionWorker.value.company_id) = $event)),
                              onSearch: searchCompanies,
                              "show-search": ""
                            }, null, 8, ["options", "value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.is_subcontractor,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((constructionWorker.value.is_subcontractor) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.is_subcontractor)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: constructionWorker.value.subcontractor_company_name,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((constructionWorker.value.subcontractor_company_name) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_5,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.document_type,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((constructionWorker.value.document_type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("ID-bewijs")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Paspoort")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 3 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Rijbewijs")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createVNode(_component_a_select, {
                          placeholder: "Kies nationaliteit",
                          "field-names": { label: 'nationality', value: 'id' },
                          filterOption: filterNationalities,
                          options: countries.value,
                          value: constructionWorker.value.nationality_id,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((constructionWorker.value.nationality_id) = $event)),
                          "show-search": ""
                        }, null, 8, ["options", "value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createVNode(_component_a_select, {
                          placeholder: "Kies land van uitgifte",
                          "field-names": { label: 'name', value: 'id' },
                          filterOption: filterItems,
                          options: countries.value,
                          value: constructionWorker.value.document_country_id,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((constructionWorker.value.document_country_id) = $event)),
                          onChange: countryOfIssueChanged,
                          "show-search": ""
                        }, null, 8, ["options", "value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        (constructionWorker.value.nationality_id === 20)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Let op! Het Bulgaarse BSN begint met ЕГН / Personal No."))
                          : _createCommentVNode("", true),
                        (constructionWorker.value.nationality_id === 107)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Let op! Het Roemeense BSN begint met CNP / PIN."))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.personal_identification_number,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((constructionWorker.value.personal_identification_number) = $event)),
                          onBlur: validateBSN
                        }, null, 8, ["value"]),
                        (!validBSN.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "BSN ongeldig / Invalid Personal Identification Number!"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.firstname,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((constructionWorker.value.firstname) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.lastname,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((constructionWorker.value.lastname) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createVNode(_component_a_date_picker, {
                          placeholder: "Selecteer een geboortedatum",
                          format: "DD-MM-YYYY",
                          "disabled-date": disabledDatesOfBirth,
                          value: constructionWorker.value.date_of_birth,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((constructionWorker.value.date_of_birth) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        (constructionWorker.value.nationality_id === 107)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Let op! Het Roemeense documentnr. kan ook beginnen met SERIA (2 letters) + NR (aantal cijfers)."))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.document_number,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((constructionWorker.value.document_number) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createVNode(_component_a_date_picker, {
                          placeholder: "Selecteer een datum",
                          format: "DD-MM-YYYY",
                          "disabled-date": disabledDatesInPast,
                          value: constructionWorker.value.document_expiry_date,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((constructionWorker.value.document_expiry_date) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_unref(EERMember))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_18,
                            _createVNode(Uploader, {
                              multiple: false,
                              "current-count": constructionWorker.value.idFront.length,
                              onNewFileUploaded: _cache[13] || (_cache[13] = ($event: any) => (constructionWorker.value.idFront.push($event)))
                            }, null, 8, ["current-count"]),
                            (constructionWorker.value.idFront.length)
                              ? (_openBlock(), _createBlock(UploadQueue, {
                                  key: 0,
                                  files: constructionWorker.value.idFront,
                                  onFileDeleted: _cache[14] || (_cache[14] = ($event: any) => (constructionWorker.value.idFront = []))
                                }, null, 8, ["files"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_19,
                            _createVNode(Uploader, {
                              multiple: false,
                              "current-count": constructionWorker.value.idBack.length,
                              onNewFileUploaded: _cache[15] || (_cache[15] = ($event: any) => (constructionWorker.value.idBack.push($event)))
                            }, null, 8, ["current-count"]),
                            (constructionWorker.value.idBack.length)
                              ? (_openBlock(), _createBlock(UploadQueue, {
                                  key: 0,
                                  files: constructionWorker.value.idBack,
                                  onFileDeleted: _cache[16] || (_cache[16] = ($event: any) => (constructionWorker.value.idBack = []))
                                }, null, 8, ["files"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_20,
                        _createVNode(Uploader, {
                          multiple: false,
                          "current-count": constructionWorker.value.portraitPhoto.length,
                          onNewFileUploaded: _cache[17] || (_cache[17] = ($event: any) => (constructionWorker.value.portraitPhoto.push($event)))
                        }, null, 8, ["current-count"]),
                        (constructionWorker.value.portraitPhoto.length)
                          ? (_openBlock(), _createBlock(UploadQueue, {
                              key: 0,
                              files: constructionWorker.value.portraitPhoto,
                              onFileDeleted: _cache[18] || (_cache[18] = ($event: any) => (constructionWorker.value.portraitPhoto = []))
                            }, null, 8, ["files"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_21,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.zipcode,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((constructionWorker.value.zipcode) = $event)),
                          onChange: getAddressByZipcode
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_22,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.housenumber,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((constructionWorker.value.housenumber) = $event)),
                          onChange: getAddressByZipcode
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_23,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.street,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((constructionWorker.value.street) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: constructionWorker.value.city,
                          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((constructionWorker.value.city) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_unref(EERMember))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_25,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: constructionWorker.value.residence_permit,
                              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((constructionWorker.value.residence_permit) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            (constructionWorker.value.residence_permit === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Een verblijfsvergunning is verplicht!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.residence_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_27,
                            _hoisted_28,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: constructionWorker.value.work_permit,
                              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((constructionWorker.value.work_permit) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            (constructionWorker.value.work_permit === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Een Nederlandse werkvergunning is verplicht!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_30,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: constructionWorker.value.work_permit_number,
                              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((constructionWorker.value.work_permit_number) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 7 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_31,
                            _createVNode(_component_a_date_picker, {
                              placeholder: "Selecteer een datum",
                              format: "DD-MM-YYYY",
                              "disabled-date": disabledDatesInPast,
                              value: constructionWorker.value.work_permit_expiry_date,
                              "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((constructionWorker.value.work_permit_expiry_date) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_32,
                            _createVNode(Uploader, {
                              multiple: false,
                              "current-count": constructionWorker.value.permitFront.length,
                              onNewFileUploaded: _cache[27] || (_cache[27] = ($event: any) => (constructionWorker.value.permitFront.push($event)))
                            }, null, 8, ["current-count"]),
                            (constructionWorker.value.permitFront.length)
                              ? (_openBlock(), _createBlock(UploadQueue, {
                                  key: 0,
                                  files: constructionWorker.value.permitFront,
                                  onFileDeleted: _cache[28] || (_cache[28] = ($event: any) => (constructionWorker.value.permitFront = []))
                                }, null, 8, ["files"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 9 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_33,
                            _createVNode(Uploader, {
                              multiple: false,
                              "current-count": constructionWorker.value.permitBack.length,
                              onNewFileUploaded: _cache[29] || (_cache[29] = ($event: any) => (constructionWorker.value.permitBack.push($event)))
                            }, null, 8, ["current-count"]),
                            (constructionWorker.value.permitBack.length)
                              ? (_openBlock(), _createBlock(UploadQueue, {
                                  key: 0,
                                  files: constructionWorker.value.permitBack,
                                  onFileDeleted: _cache[30] || (_cache[30] = ($event: any) => (constructionWorker.value.permitBack = []))
                                }, null, 8, ["files"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_34,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.vca_certified,
                          "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((constructionWorker.value.vca_certified) = $event)),
                          onChange: vcaChanged
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.vca_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 10 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_35,
                            _createVNode(_component_a_date_picker, {
                              placeholder: "Selecteer een datum",
                              format: "DD-MM-YYYY",
                              "disabled-date": disabledDatesInPast,
                              value: constructionWorker.value.vca_expiry_date,
                              "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((constructionWorker.value.vca_expiry_date) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_36,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.gpi_certified,
                          "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((constructionWorker.value.gpi_certified) = $event)),
                          onChange: gpiChanged
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.gpi_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 11 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_37,
                            _createVNode(_component_a_date_picker, {
                              placeholder: "Selecteer een datum",
                              format: "DD-MM-YYYY",
                              "disabled-date": disabledDatesInPast,
                              value: constructionWorker.value.gpi_expiry_date,
                              "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((constructionWorker.value.gpi_expiry_date) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_38,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.pu_certified,
                          "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((constructionWorker.value.pu_certified) = $event)),
                          onChange: puChanged
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.pu_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_39,
                            _createVNode(_component_a_date_picker, {
                              placeholder: "Selecteer een datum",
                              format: "DD-MM-YYYY",
                              "disabled-date": disabledDatesInPast,
                              value: constructionWorker.value.pu_expiry_date,
                              "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((constructionWorker.value.pu_expiry_date) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_40,
                        _hoisted_41,
                        _createVNode(SignatureField, {
                          "return-type": "file",
                          "signature-name": _unref(signatureName),
                          onSignatureSave: saveSignature,
                          onSignatureCleared: _cache[37] || (_cache[37] = ($event: any) => (constructionWorker.value.signature = []))
                        }, null, 8, ["signature-name"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          disabled: !_unref(requiredFieldsCompleted),
                          onClick: storeConstructionWorker
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Registreren")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})